export const CHANNEL_NAMES = {
  CREATE_KOT: "create-kot",
  KOT_REVERSAL: "kot-reversal",
};

export const EVENT_NAMES = {
  CREATE_KOT: "new-kot-created",
};
